import React from 'react'
import * as translator from "../../utils/translator";
import "./BonusBanner.css"


const getLanguageFromPath = (): string => {
    const segments = window.location.pathname.split('/').filter(Boolean);
    const supportedLanguages = ['de', 'fr', 'en'];
    for (const segment of segments) {
        if (supportedLanguages.includes(segment)) {
            return segment;
        }
    }
    return 'de';
};

const BonusBanner = () => {
    const language = getLanguageFromPath();

    const urlParams = new URLSearchParams(window.location.search);
    let deeplinkCoupon = urlParams.get('cpn');
    if (deeplinkCoupon) {
        sessionStorage.setItem('cpn', deeplinkCoupon);
    }else{
        deeplinkCoupon = sessionStorage.getItem('cpn');
    }

    if (window.location.href.includes("shipping_new")) {
        return <></>
    }


    return (
        <>
            {deeplinkCoupon &&
                <div className='bonus-banner'>{translator.translate(language,"default","BonusBanner/text")}</div>
            }
        </>
    )
}

export default BonusBanner